module.exports = __webpack_public_path__ + "img/stardust_painted.9d6f70d3.png";